import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SearchService {
  private visibilityChanges = new BehaviorSubject<boolean>(false);
  public textChanges = new Subject<string>();
  public initText = new BehaviorSubject<string>('');

  public setVisibility(visibility: boolean) {
    this.visibilityChanges.next(visibility);
  }

  public getVisibility(): boolean {
    return this.visibilityChanges.value;
  }

  public visibilityObservable(): Observable<boolean> {
    return this.visibilityChanges.asObservable();
  }

  public emitText(text: string) {
    this.textChanges.next(text);
  }

  public setInitText(text: string) {
    this.initText.next(text)
  }

  public searchObservable(): Observable<string> {
    return this.textChanges.asObservable();
  }
}
